// extracted by mini-css-extract-plugin
module.exports = {"crossLocationIcon":"_crossLocationIcon--2h5_l","crossLocationIconWithConflictIcon":"_crossLocationIconWithConflictIcon--ZQnl9"};